import { styledComponent } from '@hermes/web-components'
import NextImage from 'next/image'

export const StyledContainer = styledComponent('div')`
  display: flex;
  gap: 16px;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  @media (max-width: 768px) {
  width: 100%;
  justify-content: space-between;
  padding: 0 12px;
  }
  `

export const StyledImage = styledComponent(NextImage)`
  margin-top: -50%;
  margin-left: -50%;
  `

export const StyledText = styledComponent('a')`
  font-weight: 500;
  font-size: 14px;
  color: #11245A;
  width: 165px;
  text-decoration: none;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;    
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: 768px) {
    width: 100%;
    white-space: normal;
  }
  `

export const SubContainer = styledComponent('div')`
  display: flex;
  gap: 16px;
  align-items: center;
  @media (max-width: 768px) {
  gap: 20px;
  }`

export const ImageContainer = styledComponent('span')`
  width: 30px;
  height: 30px;
  min-width: 30px;
  `
